/**
 * Footer menu columns as accordions on a phone.
 *
 * Each menu column is a <details>, open in the markup so the footer is complete
 * without JavaScript. Below 750px they start closed and toggle like any
 * accordion. On wider screens they are held open and the toggle is disabled —
 * there the heading is a column title, not a control.
 *
 * Re-synced when the breakpoint is crossed, so rotating a tablet or resizing
 * a window never strands a column closed on desktop.
 *
 * Guarded, in case the footer is ever rendered twice (the theme editor
 * re-renders sections in place).
 */
(() => {
  if (customElements.get('footer-accordion')) return;

  const MOBILE = '(max-width: 749px)';

  class FooterAccordion extends HTMLElement {
    connectedCallback() {
      this.items = Array.from(this.querySelectorAll('details.footer-acc'));
      if (!this.items.length) return;

      this.mq = window.matchMedia(MOBILE);
      this.sync = () => {
        const mobile = this.mq.matches;
        this.classList.toggle('is-accordion', mobile);
        for (const item of this.items) {
          item.open = !mobile;
          const summary = item.querySelector('summary');
          // Out of the tab order where it does nothing.
          if (summary) summary.tabIndex = mobile ? 0 : -1;
        }
      };

      // Keyboard activation of a summary arrives as a click too, so this one
      // listener disables both on desktop.
      this.addEventListener('click', (event) => {
        if (!this.mq.matches && event.target.closest('summary')) event.preventDefault();
      });

      this.mq.addEventListener('change', this.sync);
      this.sync();
    }

    disconnectedCallback() {
      this.mq?.removeEventListener('change', this.sync);
    }
  }

  customElements.define('footer-accordion', FooterAccordion);
})();
